import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import ApexChart from "views/Charts/ApexRadial.js";
import dimensionalData from "./MockData/dimensions.js";
import Carousel from "react-elastic-carousel";
import MatButton from "./DashStyles/materialButton.js";
import Hidden from "@material-ui/core/Hidden";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Tooltip from "@material-ui/core/Tooltip";
import Button from "@material-ui/core/Button";
import Refresh from "@material-ui/icons/Refresh";
import Edit from "@material-ui/icons/Edit";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import Chart from "react-apexcharts";
import CardFooter from "components/Card/CardFooter.js";
import AccessTime from "@material-ui/icons/AccessTime";
const selectedDimension = {
  id: 4,
  color: ["#47bac1"],
  title: "Placeholder_2",
  barTitle: "Placeholder_Dimension_2",
  description: `This is a placeholder for employee data to be monitored by managers. Data is obtained via the employee
    Web Application. This data in no way reflects actual values.`,
  data: {
    labels: [
      "Jan 2019",
      "Apr 2019",
      "Jul 2019",
      "Oct 2019",
      "Jan 2020",
      "Apr 2020",
      "Jul 2020",
    ],
    series: [[54, 44, 32, 78, 55, 45, 89]],
    mockData: [{ name: "placeholder", data: [5, 45, 35, 34, 34, 34, 19] }],
    currentAverage: 56,
  },
};
const options = {
  chart: {
    id: "basic-bar",
  },
  xaxis: {
    categories: selectedDimension.data.labels,
  },
  dataLabels: {
    enabled: false,
  },
  plotOptions: {
    bar: {
      colors: {
        ranges: [
          {
            from: 0,
            to: 100,
            color: "#41babe",
          },
        ],
      },
    },
  },
};

const breakPoints = [
  { width: 1, itemsToShow: 1 },
  { width: 400, itemsToShow: 3 },
  { width: 768, itemsToShow: 4 },
  { width: 1200, itemsToShow: 5 },
];

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  cardHeader: {
    marginBottom: "20px",
  },
  textCenter: {
    textAlign: "center",
  },
}));
// "#278ccf"
export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const dimensions = React.useState(dimensionalData)[0];
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" style={{ background: "#277ecf" }}>
        <Tabs
          centered={true}
          value={value}
          onChange={handleChange}
          aria-label="simple tabs example"
        >
          {dimensions.map((dimension, idx) => (
            <Tab
              key={idx}
              label={`${dimension.title}`}
              {...a11yProps(dimension.id)}
              style={{
                fontFamily: "Arial",
                textTransform: "none",
                fontSize: "15px",
              }}
            />
          ))}
        </Tabs>
      </AppBar>

      <TabPanel value={value} index={0}>
        <CardBody className="display-charts-card-body">
          <Hidden xsDown>
            <Carousel
              breakPoints={breakPoints}
              pagination={false}
              //verticalMode
            >
              {dimensions.map((dimension, idx) => (
                <ApexChart
                  key={idx}
                  colors={
                    dimension.data.currentAverage < 54
                      ? ["#af6bb0"]
                      : dimension.data.currentAverage < 66
                      ? ["#47bac1"]
                      : ["#15a4fa"]
                  }
                  dimension={dimension.title}
                  series={[dimension.data.currentAverage]}
                />
              ))}
            </Carousel>
          </Hidden>
          <Hidden smUp>
            {" "}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "25vh",
              }}
            >
              <Carousel
                breakPoints={breakPoints}
                pagination={true}
                //verticalMode
                showArrows={false}
              >
                {dimensions.map((dimension, idx) => (
                  <ApexChart
                    key={idx}
                    colors={
                      dimension.data.currentAverage < 54
                        ? ["#af6bb0"]
                        : dimension.data.currentAverage < 66
                        ? ["#47bac1"]
                        : ["#15a4fa"]
                    }
                    dimension={dimension.title}
                    series={[dimension.data.currentAverage]}
                  />
                ))}
              </Carousel>
            </div>
          </Hidden>
          <Hidden xsDown>
            <div className="button-container">
              <MatButton>Example Dimension Summaries</MatButton>
            </div>
          </Hidden>
        </CardBody>
      </TabPanel>
      {dimensions.map((dimension, idx) => (
        <TabPanel value={value} key={idx} index={idx + 1}>
          <CardBody>
            <GridContainer
              justify="space-between"
              alignItems="center"
              direction="row"
            >
              <GridItem xs={6}>
                <Card chart className={classes.cardHover}>
                  <CardHeader
                    style={{ background: "#F0F8FF" }}
                    className={classes.cardHeaderHover}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "35vh",
                      }}
                    >
                      <ApexChart
                        // This color dynamic setting doesnt work
                        // ApexChart calcs color value on initial render
                        // When SelectedDimension changes series value will render again however..
                        // color remains static
                        colors={["#af6bb0"]}
                        dimension={dimension.title}
                        series={[dimension.data.currentAverage]}
                      />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <div className={classes.cardHoverUnder}>
                      <Tooltip
                        id="tooltip-top"
                        title="Refresh"
                        placement="bottom"
                        classes={{ tooltip: classes.tooltip }}
                      >
                        <Button simple color="info" justIcon>
                          <Refresh className={classes.underChartIcons} />
                        </Button>
                      </Tooltip>
                      <Tooltip
                        id="tooltip-top"
                        title="Change Date"
                        placement="bottom"
                        classes={{ tooltip: classes.tooltip }}
                      >
                        <Button color="transparent" simple justIcon>
                          <Edit className={classes.underChartIcons} />
                        </Button>
                      </Tooltip>
                    </div>

                    <h4 className={classes.cardTitle}>
                      Selected Dimension Over Time{" "}
                    </h4>
                    <p className={classes.cardCategory}>
                      <span className={classes.successText}>
                        <ArrowUpward className={classes.upArrowCardCategory} />{" "}
                        55%
                      </span>{" "}
                      increase in average scores.
                    </p>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> updated 4 minutes ago
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={6}>
                <Card chart className={classes.cardHover}>
                  <CardHeader
                    style={{ background: "#F0F8FF" }}
                    className={classes.cardHeaderHover}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        height: "35vh",
                      }}
                    >
                      <Chart
                        width={400}
                        options={options}
                        series={selectedDimension.data.mockData}
                        type="bar"
                      />
                    </div>
                  </CardHeader>
                  <CardBody>
                    <div className={classes.cardHoverUnder}>
                      <Tooltip
                        id="tooltip-top"
                        title="Refresh"
                        placement="bottom"
                        classes={{ tooltip: classes.tooltip }}
                      >
                        <Button simple color="info" justIcon>
                          <Refresh className={classes.underChartIcons} />
                        </Button>
                      </Tooltip>
                      <Tooltip
                        id="tooltip-top"
                        title="Change Date"
                        placement="bottom"
                        classes={{ tooltip: classes.tooltip }}
                      >
                        <Button color="transparent" simple justIcon>
                          <Edit className={classes.underChartIcons} />
                        </Button>
                      </Tooltip>
                    </div>
                    <h4 className={classes.cardTitle}>
                      Selected Dimension Over Time{" "}
                    </h4>
                    <p className={classes.cardCategory}>
                      <span className={classes.successText}>
                        <ArrowUpward className={classes.upArrowCardCategory} />{" "}
                        55%
                      </span>{" "}
                      increase in average scores.
                    </p>
                  </CardBody>
                  <CardFooter chart>
                    <div className={classes.stats}>
                      <AccessTime /> updated 4 minutes ago
                    </div>
                  </CardFooter>
                </Card>
              </GridItem>
              <GridItem xs={12}>
                <div className={classes.typo} style={{ marginTop: "4em" }}>
                  <p>**{dimension.description}</p>
                </div>
              </GridItem>
            </GridContainer>
          </CardBody>
        </TabPanel>
      ))}
    </div>
  );
}
